import {
  extractCoordinatesFromGeocodedAddress,
  normalizeGeocodedAddress
} from '../../modules/map/utilities/clickGeocoding'

class StoreClick {
  constructor (
    id = undefined,
    linkId,
    clickedBy,
    ip,
    geocodedAddress,
    fromMobile,
    fromDesktop,
    os,
    browser,
    createdAt,
    latitude,
    longitude
  ) {
    this.id = id
    this.linkId = linkId
    this.clickedBy = clickedBy
    this.ip = ip
    this.fromMobile = fromMobile
    this.fromDesktop = fromDesktop
    this.os = os
    this.browser = browser
    this.createdAt = createdAt

    const extractedCoordinates = extractCoordinatesFromGeocodedAddress(geocodedAddress)
    const apiLatitude = typeof latitude === 'number' ? latitude : undefined
    const apiLongitude = typeof longitude === 'number' ? longitude : undefined

    this.geocodedAddress = extractedCoordinates?.geocodedAddress ??
      normalizeGeocodedAddress(geocodedAddress) ??
      geocodedAddress ??
      null
    this.latitude = extractedCoordinates?.latitude ?? apiLatitude
    this.longitude = extractedCoordinates?.longitude ?? apiLongitude
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      // linkId is read-only
      // clickedBy is read-only
      // ip is read-only
      // geocodedAddress is read-only
      // fromMobile is read-only
      // fromDesktop is read-only
      // os is read-only
      // browser is read-only
      // createdAt is read-only
    })
  }

  static FromNormalizedRESTModel ({
    id,
    linkId,
    clickedBy,
    ip,
    geocodedAddress,
    fromMobile,
    fromDesktop,
    os,
    browser,
    createdAt,
    latitude,
    longitude
  }) {
    return new StoreClick(
      id,
      linkId,
      clickedBy,
      ip,
      geocodedAddress,
      fromMobile,
      fromDesktop,
      os,
      browser,
      createdAt,
      latitude,
      longitude
    )
  }

  toJSON () {
    return {
      id: this.id,
      linkId: this.linkId,
      clickedBy: this.clickedBy,
      ip: this.ip,
      geocodedAddress: this.geocodedAddress,
      fromMobile: this.fromMobile,
      fromDesktop: this.fromDesktop,
      os: this.os,
      browser: this.browser,
      createdAt: this.createdAt,
      latitude: this.latitude,
      longitude: this.longitude
    }
  }

  static FromJSON ({
    id,
    linkId,
    clickedBy,
    ip,
    geocodedAddress,
    fromMobile,
    fromDesktop,
    os,
    browser,
    createdAt,
    latitude,
    longitude
  }) {
    return new StoreClick(
      id,
      linkId,
      clickedBy,
      ip,
      geocodedAddress,
      fromMobile,
      fromDesktop,
      os,
      browser,
      createdAt,
      latitude,
      longitude
    )
  }
}

export default StoreClick
